
































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import HasilPenunjangSvc from "@/services/HasilPenunjang";
import { appModule } from "@/store/modules/app";
import {
  mapHasilLabPraInduksi,
  LabOrderItem,
  LabPraInduksiSumber
} from "@/utils/labPraInduksi";

@Component
export default class PemantauanAnestesiPraInduksi extends Vue {
  @Prop() pemantauan!: any;
  @Prop({ default: false }) readonly!: boolean;

  dirty = false;
  menarikLab = false;
  sumberLab: { lis_sampel: string; waktu: string; labels: Array<string> } | null = null;
  sumberLabRecordId: number | string | null = null;

  labForm: any = {
    hb: null, al: null, at: null, hmt: null,
    pt: null, aptt: null, gd: null, elektrolit: "",
    saturasi_o2: null, frekuensi_nafas: null, pola_nafas: "",
  };

  mounted() {
    this.loadData();
  }

  @Watch("pemantauan")
  onPemantauanChanged() {
    if (this.dirty) return;
    this.loadData();
  }

  @Watch("labForm", { deep: true })
  onLabFormChanged() {
    this.dirty = true;
  }

  loadData() {
    if (this.sumberLabRecordId !== (this.pemantauan?.id ?? null)) {
      this.sumberLab = null;
      this.sumberLabRecordId = null;
    }

    if (this.pemantauan?.lab_results) {
      Object.keys(this.labForm).forEach(key => {
        if (this.pemantauan.lab_results[key] !== undefined) {
          this.labForm[key] = this.pemantauan.lab_results[key];
        }
      });
      this.$nextTick(() => {
        this.dirty = false;
      });
    }
  }

  async ambilDariHasilLab() {
    if (this.readonly || this.menarikLab) return;

    const registerId = this.pemantauan?.register_id;
    if (!registerId) {
      appModule.sendErrorAlert("Nomor register tidak diketahui");
      return;
    }

    this.menarikLab = true;
    try {
      const resp = await HasilPenunjangSvc.getLabByRegister(registerId);
      const orders: Array<LabOrderItem> = (resp && resp.data) || [];

      if (!orders.length) {
        appModule.sendErrorAlert(
          "Belum ada hasil laboratorium pada kunjungan ini"
        );
        return;
      }

      const hasil = mapHasilLabPraInduksi(orders);

      if (!hasil.labels.length) {
        appModule.sendErrorAlert(
          "Hasil laboratorium yang tersedia tidak memuat parameter pra-induksi"
        );
        return;
      }

      Object.keys(hasil.values).forEach(field => {
        this.labForm[field] = hasil.values[field];
      });

      this.sumberLab = {
        lis_sampel: hasil.sumber ? hasil.sumber.lis_sampel : "",
        waktu: this.formatWaktuLab(hasil.sumber),
        labels: hasil.labels
      };
      this.sumberLabRecordId = this.pemantauan?.id ?? null;

      appModule.NoticeDelay(
        `Terisi dari hasil lab: ${hasil.labels.join(", ")}`
      );
    } catch (err) {
      return;
    } finally {
      this.menarikLab = false;
    }
  }

  formatWaktuLab(sumber: LabPraInduksiSumber | null): string {
    const waktu = (sumber && (sumber.acc_date || sumber.tgl_order)) || "";
    if (!waktu) return "";

    const m = moment(String(waktu));

    return m.isValid() ? m.format("DD-MM-YYYY HH:mm") : String(waktu);
  }

  validateStep(): boolean {
    return true;
  }

  collectPayload(): any {
    return { lab_results: this.labForm };
  }

  isDirty(): boolean {
    return this.dirty;
  }

  markSaved() {
    this.dirty = false;
  }
}
